module.exports = __webpack_public_path__ + "img/userInfoBg.934b1dd9.png";